import { Link } from 'react-router-dom';

interface WordMeaningProps {
	antonyms?: string[];
	definitions?: {
		antonyms?: string[];
		definition: string;
		synonyms?: string[];
	}[];
	partOfSpeech: string;
	synonyms?: string[];
}

export function WordMeaning({ meaning }: { meaning: WordMeaningProps }) {
	return (
		<div className='mb-10'>
			<div className="flex items-center space-x-5 my-4">
				<p className="font-bold italic">{meaning.partOfSpeech}</p>
				<hr className="flex-1 border-gray-100 dark:border-dark-500/50 border-t-2" />
			</div>
			<div className="mb-5">
				<h4 className="text-gray-600/70 text-lg mb-3 dark:text-gray-200">Meaning</h4>
				<ul className="text-gray-700 space-y-3 dark:text-white">
					{meaning.definitions?.map((definition, index) => (
						<li key={definition.definition}>{definition.definition}</li>
					))}
				</ul>
			</div>

			{meaning.synonyms && meaning.synonyms.length > 0 && (
				<div className="flex space-x-6 text-lg">
					<h6 className="text-gray-600 dark:text-gray-200">Synonyms</h6>
					<ul className='flex gap-x-4 flex-wrap '>
          {meaning.synonyms?.map((synonym, index) => (
						<li key={index}>
              <Link
							to={`/?search=${synonym}`}
							className="text-brand-purple font-bold hover:underline cursor-pointer"
						>
							<span
								key={index}
								className="text-brand-purple font-bold hover:underline cursor-pointer"
							>
								{synonym}
							</span>
						</Link>
            </li>
					))}
          </ul>
				</div>
			)}
		</div>
	);
}
